// extracted by mini-css-extract-plugin
export default {"root":"OngoingMeeting_root__PcVmG","rootFolded":"OngoingMeeting_rootFolded__XByiV"};